import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import _ from 'lodash';
import moment from 'moment';
import { createSelectionPeriode, getFirstAndLastDate } from '../../utils/billingUtils';
import { getBilling } from '../../apis/backend';
import { getFirstDayQuinzaine } from '../../utils/suitableDate';
import { checkAccess } from '../../utils/admins';
import { ERROR_GET_INVOICE } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError'
import apiService from '@dishopsaas/dishop-backend-api-service'

export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, (e, key) => {
    newData.push({
      label: e,
      icon: key === 1 ? <AccountBalanceIcon /> : <HomeIcon />
    });
  });
  return newData;
};

export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-4 col-md-3 col-lg-2';
  if (numberOfItems > 1) {
    classNameBottomNavigation = 'col-sm-6 col-md-5 col-lg-4 col-xl-3';
  }
  return classNameBottomNavigation;
};

const getLastDayQuinzaine = date => {
  if (date.isBefore(date.clone().endOf('month')) && date.isAfter(date.clone().set('date', 15))) {
    date.set('date', 15);
  } else {
    date.subtract(1, 'month').endOf('month');
  }
  return date;
};

export const createInvoicePeriod = async (newProps, component) => {
  const firstBilling = await apiService.billingGetAll({ orderByChild: 'date', limitToFirst: 1 })
  const startDate = Object.values(firstBilling)?.[0]?.date ||
    moment()
      .subtract(6, 'months')
      .format();

  const lastBilling = await apiService.billingGetAll({ orderByChild: 'date', limitToLast: 1 })

  const endDate = (lastBilling && _.values(lastBilling)?.[0]?.date) || moment().format()

  const factureData = createSelectionPeriode(
    getFirstDayQuinzaine(moment(startDate)),
    getLastDayQuinzaine(moment(endDate))
  );
  const { periode, currentYear, optionFinance } = factureData;
  const dateAndMonth = optionFinance[currentYear][0];
  const { isAllShops } = newProps;
  await updateBilling(component, dateAndMonth, isAllShops);
  await component.setState({
    periode,
    currentYear,
    optionFinance,
    dateAndMonth
  });
};

export const updateBilling = async (component, dateAndMonth, isAllShops) => {
  const { shopId, openErrorModal } = component.props;
  try {
    const { currentYear } = component.state;
    const { month, quinzaine } = dateAndMonth;
    const { firstDate, lastDate } = getFirstAndLastDate(quinzaine, month, currentYear);
    const billing = await getBilling(
      isAllShops ? 'network' : shopId,
      moment(firstDate).format(),
      moment(lastDate).format()
    );
    component.setState({
      billing
    });
  } catch (error) {
    sendCloudWatchAlert(`Could not get invoice ${error}`);
    openErrorModal(ERROR_GET_INVOICE);
  }
};

export const handleClick = (event, component) => {
  component.setState({ anchorEl: event.currentTarget });
};

export const handleClickYear = (event, component) => {
  component.setState({ anchorElYear: event.currentTarget });
};

export const handleClose = component => {
  component.setState(prevState => ({
    anchorEl: null,
    periode: prevState.periode,
    anchorElYear: null,
    currentYear: prevState.currentYear
  }));
};

export const handleFetchData = async (newPeriode, component, newProps) => {
  await component.setState({
    loadingInvoice: true,
    anchorEl: null,
    periode: newPeriode.toShow,
    dateAndMonth: newPeriode
  });
  const { isAllShops } = newProps;
  await updateBilling(component, newPeriode, isAllShops);
  component.setState({
    loadingInvoice: false
  });
};

export const handleUpdateYear = async (currentYear, component) => {
  component.setState({
    currentYear,
    anchorElYear: null,
    periode: 'Selectionnez une période'
  });
};

export const onChangeData = async (e, value, component) => {
  e.preventDefault();
  component.setState({
    selectedEntity: value
  });
};

export const handleShopsSwitch = (component, props) => {
  const { shopName, networkLegal, configLegal } = props;
  const newAccesArray = [];
  newAccesArray.push(shopName);
  if (checkAccess('features', 'globalFinances') && configLegal) {
    newAccesArray.push(networkLegal.companyName.toLowerCase());
  }
  component.setState({
    accesArray: newAccesArray
  });
};
